import { useState } from "react";
import EventBody from "./event_body";
import EventBoxContent from "./event_box_content";
import EventBoxFooter from "./event_box_footer";
import EventBoxHeader from "./event_box_header";

export default function EventBox({ item, detail,esave }) {
    const [showLike, setShowLike] = useState(1);
    const [showShare, setShowShare] = useState(1);
    const [showPost, setShowPost] = useState(1);

    return <div>
        {
            showPost === 1 &&
            <div className="bg-white rounded-xl shadow-sm text-sm font-medium border1 dark:bg-dark2">
                <EventBoxHeader
                    item={item}
                    detail={detail}
                    setShowLike={setShowLike}
                    setShowShare={setShowShare}
                    setShowPost={setShowPost}
                    showLike={showLike}
                    esave={esave}
                    showShare={showShare}
                />
                <EventBody item={item} detail={detail} />

                <EventBoxFooter
                    showLike={showLike}
                    showShare={showShare}
                    item={item}
                    detail={detail} />

                <EventBoxContent item={item} detail={detail} />
            </div>
        }
    </div>
}